import i18n from 'i18next'
import { Divider, Box, useMediaQuery } from '@mui/material'
import { Button, Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import Info24 from '@evocolabs/icons/lib/Info24'
import Close24 from '@evocolabs/icons/lib/Close24'
import Dialog from '@mui/material/Dialog'
import React, { useEffect, useState } from 'react'
import moment from 'moment-business-days'
import styles from '@/src/components/scss/Account/OrderStatus.module.scss'
import AccountPaper from '@/components/Account/AccountPaper'
import k from '@/src/i18n/keys'
import { data } from '@/src/data/Product'
import { useBackend } from '@/src/providers/BackendProvider'

const GetDisCountDialog = ({ open, setOpen }) => {
  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '12px',
          p: '48px 40px',
          textAlign: 'center'
        }
      }}
      open={open}
      onClose={() => setOpen(false)}
    >
      <Box>
        <Box
          onClick={() => {
            setOpen(false)
          }}
          sx={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            cursor: 'pointer'
          }}
        >
          <Close24 />
        </Box>
        <Typography variant="h3" sx={{ textAlign: 'center' }}>
          How to Get A Discount?
        </Typography>
        <Typography variant="body2" sx={{ mt: '8px', textAlign: 'center' }}>
          Leave your feedback for Orka One and get a $20 discount!
        </Typography>
        <Button
          id="start-now"
          sx={{ mt: '32px' }}
          size="large"
          handleClick={() => {
            window.open('/Survey/Feedback-1')
          }}
        >
          Start now
        </Button>
      </Box>
    </Dialog>
  )
}
const StatusCard = ({ setWindow, index, setIndex }) => {
  const { orderDetails } = useBackend()
  const productSkuFromBackend =
    orderDetails.results[index].infos.products[0].sku
  const productSku =
    productSkuFromBackend === ''
      ? process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_FULL_PRICE
      : productSkuFromBackend
  // bigcommerce testsite product id is different from main site, so now use the sku,but some early product do not have sku
  const isInstallmentOrder =
    orderDetails.results[index].backendVersion == 'v1' &&
    (productSku === process.env.NEXT_PUBLIC_PRODUCT_SKU_ORKA_ONE_INSTALLMENT ||
      productSku ===
        process.env.NEXT_PUBLIC_PRODUCT_SKU_ORKA_ONE_INSTALLMENT_PRICE1050)
  const installmentCampaignInfo = isInstallmentOrder
    ? orderDetails.results[index].campaign_specific_info.installment_2022_6
    : ''
  const installmentPayMonths = isInstallmentOrder
    ? installmentCampaignInfo.num_total_installments
    : ''
  const isFreeTryOnOrder =
    productSku === process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM
  const isFreeTryOnOrder21 =
    productSku === process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_3_0
  const isFreeTryOnOrder45 =
    productSku === process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_4_5
  const isNormalFullPriceHearingAids =
    productSku ===
    process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_FULL_PRICE
  const isFreeTryOnOrderWithFullPrice =
    orderDetails.results[index].infos
      .is_free_insider_program_order_with_paid_order
  const isFullPriceOrder =
    orderDetails.results[index].infos.is_full_price_insider_program_order
  const isInstallmentInsiderOrder =
    orderDetails.results[index].infos.is_installment_insider_program_order
  const img = data[productSku]?.img
  const usePhone = useMediaQuery(theme.breakpoints.down('sm'))
  const status = {
    2: 'Shipped',
    3: 'Shipped',
    4: 'Refunded',
    5: 'Cancelled',
    6: 'Declined',
    7: 'Ordered',
    8: 'Shipped',
    9: 'Ordered',
    10: !isFreeTryOnOrder && isFullPriceOrder ? 'Completed' : 'Delivered',
    11: 'Ordered',
    12: 'Ordered',
    99: 'Out for Delivery'
  }
  const [openDialog, setOpenDialog] = useState(false)
  const handleOrderDetailsButton = () => {
    setIndex(index)
    setWindow('orderDetail')
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
  }
  const basicDeliveredTime =
    orderDetails.results[index].infos?.shipment &&
    orderDetails.results[index].infos?.shipment[0]?.estimated_delivery_time
      ? moment(
          orderDetails.results[index].infos.shipment[0].estimated_delivery_time
        )
      : moment(orderDetails.results[index].infos.create_time).businessAdd(7) // 7 workdays

  const deliveredTime = basicDeliveredTime.format('YYYY-MM-DD').split('-')
  const createdTime = moment(orderDetails.results[index].infos.create_time)
    .format('YYYY-MM-DD')
    .split('-')
  const month = [
    i18n.t(k.JAN),
    i18n.t(k.FEB),
    i18n.t(k.MAR),
    i18n.t(k.APR),
    i18n.t(k.MAY),
    i18n.t(k.JUN),
    i18n.t(k.JUL),
    i18n.t(k.AUG),
    i18n.t(k.SEP),
    i18n.t(k.OCT),
    i18n.t(k.NOV),
    i18n.t(k.DEC)
  ]

  const [hasAccessoryPackage, setHasAccessoryPackage] = useState(false)
  const productDetailsInOrder = orderDetails.results[index].infos.products
  useEffect(() => {
    const AccessoryPackage = productDetailsInOrder.find(
      (item) =>
        item.product_id.toString() ===
        process.env.NEXT_PUBLIC_ACCESSORY_PACKAGE_BIGCOMMERCE_ID
    )
    if (AccessoryPackage) {
      setHasAccessoryPackage(true)
    }
  }, [productDetailsInOrder])

  return (
    <div>
      <AccountPaper className={styles.cardWrapper}>
        <div className={styles.status}>
          <div>
            <Typography variant="t1">
              {orderDetails.results[index].infos.latestRefund &&
              orderDetails.results[index].infos.latestRefund.status !== 7
                ? i18n.t(k.IN_RETURN_PROCESS)
                : status[orderDetails.results[index].infos.status_id]}
            </Typography>
          </div>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column-reverse', sm: 'column', gap: '9px' },
              mt: { xs: '8px', sm: '0px' }
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="body3"
                sx={{ color: theme.palette.grey[700] }}
              >
                Order No:&nbsp;
              </Typography>
              <Typography
                variant="Body3"
                sx={{ display: 'inline', color: theme.palette.grey[700] }}
              >
                {orderDetails.results[index].infos.bc_order_id}
              </Typography>
            </div>
            <Box>
              <Typography
                variant="body3"
                sx={{ display: 'inline-block', color: theme.palette.grey[700] }}
              >
                Order Date:&nbsp;
              </Typography>
              <Typography
                variant="Body3"
                sx={{ display: 'inline', color: theme.palette.grey[700] }}
              >
                {month[parseInt(createdTime[1]) - 1]} {createdTime[2]}
                {i18n.t(k._5)} {createdTime[0]}
              </Typography>
            </Box>
          </Box>
        </div>
        <Divider className={styles.divider} />
        <div className={styles.product}>
          <div style={{ display: 'flex', flexGrow: 1 }}>
            <img
              src={img}
              className={styles.productImg}
              width="120"
              height="120"
            />
            <div className={styles.productInfo}>
              <Typography variant={'t1'}>
                {!(isFreeTryOnOrder || isFreeTryOnOrder21 || isFreeTryOnOrder45)
                  ? data[productSku]?.titlePC
                  : 'Orka One AI hearing aids'}
              </Typography>
              {isFullPriceOrder || isInstallmentInsiderOrder ? (
                <Typography
                  variant="Body3"
                  sx={{ color: theme.palette.grey[700], mt: '4px' }}
                >
                  Keep After Try-On Period
                </Typography>
              ) : isFreeTryOnOrder ||
                isFreeTryOnOrder21 ||
                isFreeTryOnOrder45 ? (
                <Typography
                  variant="Body3"
                  sx={{ color: theme.palette.grey[700], mt: '4px' }}
                >
                  In Try-On Period
                </Typography>
              ) : isNormalFullPriceHearingAids || hasAccessoryPackage ? (
                <Typography
                  variant="Body3"
                  sx={{ color: theme.palette.grey[700], mt: '4px' }}
                >
                  Pay in Full
                </Typography>
              ) : isInstallmentOrder ? (
                <Typography
                  variant="Body3"
                  sx={{ color: theme.palette.grey[700], mt: '4px' }}
                >
                  Pay Monthly
                </Typography>
              ) : (
                <></>
              )}
              {orderDetails.results[index].infos.products[0].quantity && (
                <Typography variant="body3" sx={{ mt: '4px' }}>
                  {`Quantity: ${orderDetails.results[index].infos.products[0].quantity}`}
                </Typography>
              )}
              {data[productSku]?.size && (
                <Typography variant="body3" sx={{ mt: '4px' }}>
                  {`Size: ${data[productSku]?.size}`}
                </Typography>
              )}
              {usePhone && (
                <>
                  <Typography variant="T2" sx={{ mt: '14px', fontWeight: 600 }}>
                    {isFreeTryOnOrder ||
                    isFreeTryOnOrder21 ||
                    isFreeTryOnOrder45
                      ? 'Free'
                      : isInstallmentOrder
                        ? '$' +
                          75 +
                          '/mo. for ' +
                          installmentPayMonths +
                          ' months'
                        : '$' +
                          Number(
                            orderDetails.results[index].infos.product_amount
                          ) +
                          ''}
                  </Typography>
                </>
              )}
            </div>
          </div>
          {!usePhone && (
            <div>
              <Typography variant="T2" sx={{ textAlign: 'end', mt: '8px' }}>
                {isFreeTryOnOrder || isFreeTryOnOrder21 || isFreeTryOnOrder45
                  ? 'Free'
                  : isInstallmentOrder
                    ? '$' + 75 + '/mo. for ' + installmentPayMonths + ' months'
                    : '$' +
                      Number(orderDetails.results[index].infos.product_amount) +
                      ''}
              </Typography>
            </div>
          )}
        </div>
        {/* Christmas AccessoryPackage */}
        {hasAccessoryPackage && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: '24px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: '12px', md: '16px' }
              }}
            >
              <img
                src="https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/accessory-package.jpg"
                className={styles.productImg}
                width="120"
                height="120"
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px'
                }}
              >
                <Typography variant="t1">
                  1-Year Accessory Subscription (4 packs)
                </Typography>
                <Typography variant="Body3" color={theme.palette.grey[700]}>Pay in Full</Typography>
                <Typography variant="body3">Quantity: 1</Typography>
                <Box
                  sx={{
                    gap: '8px',
                    display: { xs: 'flex', md: 'none' },
                    flexDirection: 'row',
                    justifyContent: 'flex-start'
                  }}
                >
                  <Typography
                    as="span"
                    variant="subtitle1"
                    sx={{ textAlign: 'right' }}
                  >
                    $0
                  </Typography>
                  <Typography
                    as="span"
                    variant="body2"
                    color="#918D8C"
                    sx={{ textDecoration: 'line-through' }}
                  >
                    $100
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                gap: '4px',
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                justifyContent: 'flex-end'
              }}
            >
              <Typography
                as="span"
                variant="subtitle1"
                sx={{ textAlign: 'right' }}
              >
                $0
              </Typography>
              <Typography
                as="span"
                variant="body2"
                color="#918D8C"
                sx={{ textDecoration: 'line-through' }}
              >
                $100
              </Typography>
            </Box>
          </Box>
        )}
        {/* end of components */}
        <Divider className={styles.divider} />
        <div className={styles.orderTotal}>
          <Typography variant={'T2'}>Order Total</Typography>
          <Typography variant={'T2'}>
            {isInstallmentOrder
              ? `$${(
                  Number(installmentCampaignInfo.past_invoices[0].total) / 100
                ).toFixed(2)}`
              : `$${Number(
                  orderDetails.results[index].infos.total_amount
                ).toFixed(2)}`}
          </Typography>
        </div>
        {(isFreeTryOnOrder || isFreeTryOnOrder21 || isFreeTryOnOrder45) &&
          !isFreeTryOnOrderWithFullPrice && (
            <Box
              sx={{
                mt: '24px',
                background: '#F7F7F7',
                borderRadius: '8px',
                p: '16px'
              }}
            >
              <Typography variant="body2">
                If you're satisfied with Orka One, we'd love for you to keep
                them at a discounted price.&nbsp;
                <Box
                  onClick={() => {
                    setOpenDialog(true)
                  }}
                  sx={{
                    verticalAlign: 'middle',
                    display: 'inline-block',
                    cursor: 'pointer'
                  }}
                >
                  <Info24 />
                </Box>
              </Typography>
            </Box>
          )}
        <Box
          sx={{
            justifyContent: { xs: 'center', sm: 'flex-end' },
            mt: '24px',
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap',
            flexDirection: { xs: 'column-reverse', sm: 'row' }
          }}
        >
          <Button
            id="view-more"
            size="large"
            variant="secondary"
            handleClick={handleOrderDetailsButton}
            block={usePhone}
          >
            View More
          </Button>
          {(isFreeTryOnOrder || isFreeTryOnOrder21 || isFreeTryOnOrder45) &&
            !isFreeTryOnOrderWithFullPrice && (
              <Button
                id="keep-orka-one"
                variant="primary"
                handleClick={() => {
                  const isFreeTryOn21day =
                    orderDetails.results[index]?.infos?.products?.[0]?.sku ===
                    process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_3_0
                  const freeTryOn21dayFromOrderSummaryMark = isFreeTryOn21day
                    ? `&fto=21`
                    : ''
                  window.location.href = `${i18n.t(
                    k.INSIDERCHECKOUT_ORDERNUM
                  )}${
                    orderDetails.results[index].infos.id
                  }${freeTryOn21dayFromOrderSummaryMark}`
                }}
                size="large"
                block={usePhone}
              >
                Keep Orka One
              </Button>
            )}
        </Box>
        <GetDisCountDialog open={openDialog} setOpen={setOpenDialog} />
        {status[orderDetails.results[index].infos.status_id] === 'Shipped' && (
          <div className={styles.estWrapper}>
            <Typography
              variant="caption"
              sx={{ color: theme.palette.grey[600] }}
            >
              {i18n.t(k.ESTIMATED_DELIVERED_DATE)}
              <Typography variant="subh2">
                {' '}
                {month[Number(deliveredTime[1]) - 1]} {deliveredTime[2]}
                {i18n.t(k._5)} {deliveredTime[0]}
              </Typography>
            </Typography>
          </div>
        )}
      </AccountPaper>
    </div>
  )
}

export default StatusCard
